module.exports = __webpack_public_path__ + "img/context.60b45d4f.png";